var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tinymce-editor"},[_c('editor',{attrs:{"id":_vm.id,"init":_vm.init,"disabled":_vm.disabled},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }